import { useComponentStore } from "@wss/store";
import { persist, createJSONStorage } from "zustand/middleware";

export type ViewSetting = "grid" | "list";

export type ChromeBarState = {
  view: ViewSetting;
};

const storageKey = "ProductListingView";

function initViewStore(): ChromeBarState {
  try {
    const storage = window.localStorage?.getItem(storageKey);
    if (!storage) return { view: "grid" };
    return { view: JSON.parse(storage)?.view || "grid" };
  } catch (error) {
    return { view: "grid" };
  }
}

function useChromeBarComponentStore() {
  return useComponentStore<ChromeBarState>(
    persist(initViewStore, {
      name: storageKey,
      storage: createJSONStorage(() => window.localStorage),
    })
  );
}

export default useChromeBarComponentStore;
